export default "__VITE_ASSET__d5bf312c__"